import React from "react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Your privacy matters to us. This policy explains how Aadvan Dry Fruits collects, uses and protects your information.",
    sections: [
      ["Information We Collect", "We collect your name, phone number, email, and delivery address solely to process and deliver your orders. We do not store any payment card details as we currently operate on Cash on Delivery."],
      ["How We Use It", "Your information is used to fulfil orders, provide delivery updates, respond to enquiries and improve our services. We never sell your data to third parties."],
      ["Analytics", "We may use analytics tools such as Google Analytics and Meta Pixel to understand site usage and improve your experience. This data is aggregated and anonymised."],
      ["Data Security", "We follow reasonable security practices to protect your personal data. Access is restricted to authorised personnel only."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting care@aadvan.in."],
    ],
  },
  refund: {
    title: "Refund Policy",
    intro: "As we deal in premium food products, we maintain strict quality standards. Please read our refund terms carefully.",
    sections: [
      ["Eligibility", "Refunds or replacements are offered only for damaged, defective or incorrect items reported within 24 hours of delivery with photographic proof."],
      ["Non-Returnable", "For hygiene and safety reasons, opened or partially consumed products cannot be returned unless found defective."],
      ["Refund Process", "Approved refunds for COD orders are processed via UPI/bank transfer within 5–7 business days of approval."],
      ["Cancellations", "Orders can be cancelled free of charge before they are dispatched. Contact us immediately on WhatsApp or call."],
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "By using the Aadvan Dry Fruits website and placing an order, you agree to the following terms.",
    sections: [
      ["Ordering", "All orders are subject to product availability and delivery serviceability (within 15 KM of Sitapur). We reserve the right to cancel any order."],
      ["Pricing", "All prices are listed in Indian Rupees (₹) and are inclusive of applicable taxes unless stated otherwise. Prices may change without prior notice."],
      ["Delivery", "Delivery timelines are estimates. We are not liable for delays caused by factors beyond our control."],
      ["Product Information", "We strive for accuracy in product descriptions, nutritional data and images. Minor variations may occur naturally in food products."],
      ["Governing Law", "These terms are governed by the laws of India, with jurisdiction in Sitapur, Uttar Pradesh."],
    ],
  },
  shipping: {
    title: "Shipping Policy",
    intro: "We deliver freshness right to your doorstep, across Sitapur.",
    sections: [
      ["Delivery Area", "We currently deliver only within a 15 KM radius of our store in Sitapur, Uttar Pradesh. Serviceability can be checked using your pincode on any product page."],
      ["Delivery Slots", "Choose from Same Day Delivery (order before 4 PM), Next Day Delivery, or free Store Pickup at checkout."],
      ["Delivery Charges", "Same Day Delivery: ₹49. Next Day Delivery: Free on orders above ₹499, else ₹29. Store Pickup: Free."],
      ["Packaging", "All products are carefully packed in food-grade, tamper-evident packaging to preserve freshness during transit."],
      ["Outside Sitapur", "We currently deliver only within Sitapur. Wider shipping is coming soon — stay tuned!"],
    ],
  },
};

export default function PolicyPage({ type }) {
  const data = CONTENT[type];
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 fade-in" data-testid={`policy-${type}`}>
      <span className="text-xs uppercase tracking-[0.3em] text-gold">Legal</span>
      <h1 className="font-serif text-5xl text-forest mt-1 mb-4">{data.title}</h1>
      <p className="text-muted-foreground mb-10 leading-relaxed">{data.intro}</p>
      <div className="space-y-8">
        {data.sections.map(([title, body], i) => (
          <div key={i}>
            <h2 className="font-serif text-2xl text-forest mb-2">{i + 1}. {title}</h2>
            <p className="text-muted-foreground leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-12">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}. For questions, contact care@aadvan.in.</p>
    </div>
  );
}
